import { fullName } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const gqlQuery = gql`
  query GetUser {
    user {
      id
      customerInfo {
        id
        name {
          ...fullName
        }
      }
      accounts {
        id
        nickname
      }
    }
  }
  ${fullName}
`;

export default gqlQuery;
